

//https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/dialog

interface iMenuPrincipal{
    children?: any,
}

export default function ModalTexto(props: iMenuPrincipal){
    return  <dialog id="modalTexto" className="dialogoCentrado">
                <div className="menuModalTexto">
                    <button className="botonCerrar" onClick={() => {
                        const dialogPrincipal = document.querySelector("#modalTexto") as HTMLDialogElement;
                        if ( dialogPrincipal != null)
                            dialogPrincipal?.close();
                    }}>(X)</button>
                    {props?.children}
                </div>
            </dialog>
}